import React from "react";
const helpcanvas = {
  display: 'grid',
  gridTemplateColumns: '2fr 3fr 5fr',
  gridTemplateRows: 'min-content 1fr',
  backgroundColor: "#f2f2f2",
  height: '100vh',
  width: '100%',
  rowGap: '24px',
  columnGap: '14px',
  padding: '0 0 14px 0',
};

const helptitle = {
  color: "#222",
  backgroundColor: "#f2f2f2",
  padding: "2px",
  fontFamily: "Arial",
  fontSize: "13px",
};

const helpimg = {
    color: "#222",
    backgroundColor: "#f2f2f2",
    padding: "2px",
    fontFamily: "Arial",
  };

const UIVSDash = {
    name: 'VS Dashboard',
    imageUrl: './images/VSDash.png',
    imageSize: "99%",
    bradius: 20,
  };

const UIVSRiskgrade = {
    name: 'VS Risk Grade',
    imageUrl: '../../images/VSRiskgrade.png',
    imageSize: "60%",
    bradius: 20,
  };

const UIVSTrendfilter = {
    name: 'VS Trend Filter',
    imageUrl: '../../images/VSTrendfilter.png',
    imageSize: "30%",
    bradius: 20,
  };

const UIVSTrendChart = {
    name: 'VS Trend Chart',
    imageUrl: '../../images/VSTrendChart.png',
    imageSize: "90%",
    bradius: 20,
  };

const UIVSTop5 = {
    name: 'VS Top 5 OS',
    imageUrl: '../../images/VSTop5.png',
    imageSize: "60%",
    bradius: 20,
  };

const UIVSTop10 = {
    name: 'VS Top 10 Targets',
    imageUrl: '../../images/VSTop10.png',
    imageSize: "90%",
    bradius: 20,
  };

const UIVSAllvulnhosts = {
    name: 'VS Top 10 Targets',
    imageUrl: '../../images/VSAllvulnhosts.png',
    imageSize: "90%",
    bradius: 20,
  };

const UIVSRootbutton = {
    name: 'Root Cause Button',
    imageUrl: '../../images/VSRootbutton.png',
    imageSize: "40%",
    bradius: 20,
  };

const UIVSActivescans = {
    name: 'VS Active Scans',
    imageUrl: '../../images/VSActivescans.png',
    imageSize: "70%",
    bradius: 20,
  };

  const UIVSLast5 = {
    name: 'Last 5 Scans',
    imageUrl: '../../images/VSLast5.png',
    imageSize: "70%",
    bradius: 20,
  };

const UIVSScheduledscans = {
    name: 'Last 5 Scans',
    imageUrl: '../../images/VSScheduledscans.png',
    imageSize: "70%",
    bradius: 20,
  };

const UIVSMitprogress = {
    name: 'Last 5 Scans',
    imageUrl: '../../images/VSMitprogress.png',
    imageSize: "70%",
    bradius: 20,
  };


export const VSDash = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Vulnerability Scan Dashboard</b><br/><br/>
      The Vulnerability Scan Dashboard provides an overview of how your previous or current vulnerability scans have performed 
      or are performing. Through this, determine how vulnerable your instance is based on system patch statuses and software 
      versions known to contain vulnerabilities. <br/><br/>
      Not all vulnerabilities are easily exploitable, but they are ranked in terms of ease of exploitation and magnitude of impact. 
      Critical vulnerabilities are considered generally exploitable with very high impact.

      </div>
      <div style={helpimg}>
      <img
        src={UIVSDash.imageUrl}
        alt={'Image of ' + UIVSDash.name}
        style={{
          width: UIVSDash.imageSize,
          borderRadius: UIVSDash.bradius,
        }}
      />
      </div>
    </div>
  );
};
 
export const VSRiskGrade = () => {
  return (
    <div style={helpcanvas}>
      <div style={{ marginLeft: "310px" }}></div>
      <div style={helptitle}><b>Vulnerability Risk Grade</b><br/><br/>
      The Vulnerability Risk Grade is based on the number of vulnerabilities (CVEs) found during all the vulnerability scans 
      performed in the current reporting period (Month or Quarter), and the combined overall severity of the vulnerabilities.  <br/><br/>
      The main grade shown under Vulnerability Risk Grade is for the current reporting period (Month or Quarter), and the 
      grade shown just below that in a smaller font size is for the previous reporting period. A quick comparison lets you 
      see how your organization is progressing over your selected time period, whether it be monthly or quarterly. 
      </div>
      <div style={helpimg}>
      <img
        src={UIVSRiskgrade.imageUrl}
        alt={'Image of ' + UIVSRiskgrade.name}
        style={{
          width: UIVSRiskgrade.imageSize,
          borderRadius: UIVSRiskgrade.bradius,
        }}
      />
      </div>
    </div>
  );
};
 
export const VSTrendChart = () => {
  return (
    <div style={helpcanvas}>
      <div style={{ marginLeft: "310px" }}></div>
      <div style={helptitle}><b>Vulnerability Trend Chart</b><br/><br/>
      The Vulnerability Trend Chart provides a quick view of the history of your scanning efforts for your instance over 
      various time periods. Vulnerability scan trends for your instance depend on the severity levels and the number of 
      the vulnerabilities discovered over the selected time period (Week, Month, Quarter or Year). <br/><br/>
      Use the W, M, Q or Y options at the top right of the chart to select your reporting period. <br/><br/>
      <img
        src={UIVSTrendfilter.imageUrl}
        alt={'Image of ' + UIVSTrendfilter.name}
        style={{
          width: UIVSTrendfilter.imageSize,
          borderRadius: UIVSTrendfilter.bradius,
        }}
      /><br/><br/>
      Each severity level can be switched on or off to filter the view. To do so, simply click the severity level on the chart legend at the top.
      </div>
      <div style={helpimg}>
      <img
        src={UIVSTrendChart.imageUrl}
        alt={'Image of ' + UIVSTrendChart.name}
        style={{
          width: UIVSTrendChart.imageSize,
          borderRadius: UIVSTrendChart.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const VSTop5 = () => {
  return (
    <div style={helpcanvas}>
      <div style={{ marginLeft: "310px" }}></div>
      <div style={helptitle}><b>Top 5 Operating Systems</b><br/><br/>
      The Top 5 Operating Systems illustrate the number of times a specific OS was scanned during the current reporting period. 
      It also shows the number of Targets using that OS.
      </div>
      <div style={helpimg}>
      <img
        src={UIVSTop5.imageUrl}
        alt={'Image of ' + UIVSTop5.name}
        style={{
          width: UIVSTop5.imageSize,
          borderRadius: UIVSTop5.bradius,
        }}
      />
      </div>
    </div>
  );
};
 
export const VSTop10 = () => {
  return (
    <div style={helpcanvas}>
      <div style={{ marginLeft: "310px" }}></div>
      <div style={helptitle}><b>Targets with the most vulnerabilities</b><br/><br/>
      The Top 10 Targets with Most Vulnerabilities display provides a breakdown of vulnerabilities by target, within the current 
      reporting period. Targets are ranked by the number of vulnerabilities found on each, where the Target with the most 
      vulnerabilities appears first. The reporting period can be a Week, Month, Quarter or Year. 
      </div>
      <div style={helpimg}>
      <img
        src={UIVSTop10.imageUrl}
        alt={'Image of ' + UIVSTop10.name}
        style={{
          width: UIVSTop10.imageSize,
          borderRadius: UIVSTop10.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const VSAllvulnhosts = () => {
  return (
    <div style={helpcanvas}>
      <div style={{ marginLeft: "310px" }}></div>
      <div style={helptitle}><b>All Vulnerabilities with Impacted Hosts</b><br/><br/>
      In the All Vulnerabilities section, you can see the unique CVE breakdown by number of Targets impacted, and timespans.  <br/><br/>
      The Unique CVE Breakdown chart shows the number of CVEs for Workstations and Servers found over the past 90 
      days, broken down by severity. Keep in mind that a single CVE can exist on Workstations AND Servers, so the 
      CVE is counted ONCE in the "Total Unique" value, but may appear and be counted for both workstations and servers. <br/><br/>
      Unique CVE Breakdown by Timespan offers similar information, except the CVE counts are separated by and broken 
      down by CVE published date. These time periods go back to up to a year. <br/><br/>
      <b>Root Cause Analysis</b><br/><br/>
      <img
        src={UIVSRootbutton.imageUrl}
        alt={'Image of ' + UIVSRootbutton.name}
        style={{
          width: UIVSRootbutton.imageSize,
          borderRadius: UIVSRootbutton.bradius,
        }}
      /><br/><br/>
      The Root Cause Analysis button will allow further drill-down into the root causes of CVEs in the environment and, 
      in many cases, allow you to apply an update to address that root cause right within the CYRISMA web interface.  <br/><br/>
      Click the Root Cause Analysis button to see the top-level list of all root causes.
      </div>
      <div style={helpimg}>
      <img
        src={UIVSAllvulnhosts.imageUrl}
        alt={'Image of ' + UIVSAllvulnhosts.name}
        style={{
          width: UIVSAllvulnhosts.imageSize,
          borderRadius: UIVSAllvulnhosts.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const VSActivescans = () => {
  return (
    <div style={helpcanvas}>
      <div style={{ marginLeft: "310px" }}></div>
      <div style={helptitle}><b>Active Vulnerability Scans</b><br/><br/>
      This shows any active vulnerability scans that you are currently running for your instance, and the percentage progress on each.
      </div>
      <div style={helpimg}>
      <img
        src={UIVSActivescans.imageUrl}
        alt={'Image of ' + UIVSActivescans.name}
        style={{
          width: UIVSActivescans.imageSize,
          borderRadius: UIVSActivescans.bradius,
        }}
      />
      </div>
    </div>
  );
};


export const VSLast5 = () => {
  return (
    <div style={helpcanvas}>
      <div style={{ marginLeft: "310px" }}></div>
      <div style={helptitle}><b>Last 5 Vulnerability Scans</b><br/><br/>
      This shows the last 5 vulnerability scans that have been performed on your instance.
      </div>
      <div style={helpimg}>
      <img
        src={UIVSLast5.imageUrl}
        alt={'Image of ' + UIVSLast5.name}
        style={{
          width: UIVSLast5.imageSize,
          borderRadius: UIVSLast5.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const VSScheduledscans = () => {
  return (
    <div style={helpcanvas}>
      <div style={{ marginLeft: "310px" }}></div>
      <div style={helptitle}><b>Scheduled Vulnerability Scans </b><br/><br/>
      These are all the vulnerability scans scheduled for your instance. You can see the scan names, 
      whether they are set as one-time or recurring, the next scan date, and the number of targets selected for each scan. 
      </div>
      <div style={helpimg}>
      <img
        src={UIVSScheduledscans.imageUrl}
        alt={'Image of ' + UIVSScheduledscans.name}
        style={{
          width: UIVSScheduledscans.imageSize,
          borderRadius: UIVSScheduledscans.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const VSMitprogress = () => {
  return (
    <div style={helpcanvas}>
      <div style={{ marginLeft: "310px" }}></div>
      <div style={helptitle}><b>Mitigation Plans in Progress</b><br/><br/>
      This is an overview of the mitigation plans for vulnerability scans that are currently in progress for your instance.
      </div>
      <div style={helpimg}>
      <img
        src={UIVSMitprogress.imageUrl}
        alt={'Image of ' + UIVSMitprogress.name}
        style={{
          width: UIVSMitprogress.imageSize,
          borderRadius: UIVSMitprogress.bradius,
        }}
      />
      </div>
    </div>
  );
};

